<template>
	<section>
		<b-card no-body>
			<b-tabs no-fade pills card small  nav-class="nav-style" align="center">
				<b-tab title="General" active>
					<ModelForm
						:modelId="modelId"
						resource="sales-channels"
						:modelInfo="defaultModelInfo"
						v-slot="slotProps"
						@fetch="$emit('update:unableEdit',!$hasPermission('channel.edit'))"
						:params.sync="defaultModelInfo"
						:successCallback="successCallback"
					>
						<b-form-row>
							<b-form-group :disabled="unableEdit" class="col-4" label="Codigo">
								<b-form-input
									type="text"
									size="sm"
									v-model="slotProps.modelInfo.code"
									required
								/>
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-4" label="Nombre">
								<b-form-input
									type="text"
									size="sm"
									v-model="slotProps.modelInfo.name"
									required
								/>
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-4" label="Estado">
								<b-form-select
									size="sm"
									v-model="slotProps.modelInfo.status"
									:options="statusOptions"
								></b-form-select>
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group :disabled="unableEdit" class="col-6" label="Descripcion">
								<b-textarea
									size="sm"
									v-model="slotProps.modelInfo.description"
								/>
							</b-form-group>
						</b-form-row>
						<hr />
						<div class="text-right">
							<b-button :disabled="unableEdit" variant="primary" type="submit">{{
								modelId > 0 ? "Actualizar" : "Guardar"
							}}</b-button>
						</div>
					</ModelForm>
				</b-tab>
				<b-tab
					v-if="modelId > 0 && this.$hasPermission('channel.ratePlan') "
					title="Destinos y Tarifas"
				>
					<RatePlansModule :idSaleChannel="modelId"></RatePlansModule>
				</b-tab>

				<b-tab v-if="modelId > 0 && this.$hasPermission('channel.ratePlan') " title="Promociones" lazy>
					<h1>Promociones</h1>
					<PromotionsList :salesChannelId="modelId"></PromotionsList>
				</b-tab>
				<b-tab
					v-if="modelId > 0 && $hasPermission('channel.contact.show')"
					@click="
						loadedTabs.push('contacts');
						currentTab = 'contacts';
					"
					title="Contactos"
				>
					<Contacts
						v-if="loadedTabs.includes('contacts')"
						:model-id="modelId"
					/>
				</b-tab>
				<b-tab title="Configuración" v-if="$hasPermission('channel.config')">
					<b-row>
						<b-col>
							<table class="table table-striped">
								<tr>
									<th></th>
									<th>Opción</th>
									<th>Descripcion</th>
								</tr>
								<tr>
									<td> <b-form-checkbox :disabled="unableEdit" size="lg" v-model="defaultModelInfo.settingVars.blockEdit"></b-form-checkbox> </td>
									<td>Bloquear reservas</td>
									<td>Los clientes NO podrán modificar su reserva a través del portal Web Check-in</td>
								</tr>
								<tr>
									<td> <b-form-checkbox :disabled="unableEdit" size="lg" v-model="defaultModelInfo.settingVars.compareRates"></b-form-checkbox> </td>
									<td>Comparación de precios</td>
									<td>Comparar el precio registrado en la reserva con el calculo de tarifas</td>
								</tr>
								<tr>
									<td> <b-form-checkbox :disabled="unableEdit" size="lg" v-model="defaultModelInfo.settingVars.updateRatesByCalculation"></b-form-checkbox> </td>
									<td>Actualización de precios</td>
									<td>Actualizar el precio registrado en la reserva con el calculo de tarifas de forma automática. Se realizara el calculo y actualización siempre que la tarifa de venta no este marcada con la opción "Mantener precio". Tampoco se actualizaran reservas hechas en puntos de venta.</td>
								</tr>
								<tr>
									<td>
										<b-form-input type="number" size="sm" v-model="defaultModelInfo.settingVars.defaultCutoff"/>
									</td>
									<td>Cutoff por defecto</td>
									<td>Establece un cutoff global por defecto en HORAS para todas las reservas provenientes del canal de venta. (Se aplicá en caso de que no exista ninguna regla en <strong>Reglas de canal</strong> que cumpla con las caracteristicas de la reservación)</td>
								</tr>
							</table>
							<b-button :disabled="unableEdit" @click="updateSettings()" variant="primary">Actualizar</b-button>
						</b-col>
					</b-row>
				</b-tab>
			</b-tabs>

			<!-- modal cierre de tarifa -->
			<b-modal
				hide-footer
				ref="refClosingRate"
				size="md"
				:title="
					TypeOfClousure == 'expire'
					? 'Config. expiración de tarifa'
					: 'Config. expiración y duplicar tarifa'
				"
				>
				<ClosingRateModal
					@closeModal="$refs['refClosingRate'].hide()"
					ref="refBodyCloseRate"
					:TypeOfClousure="TypeOfClousure"
					@refreshTableRate="loadRatePlans()"
				/>
			</b-modal>
		</b-card>
	</section>
</template>

<script>
import ModelForm from "../../helpers/ModelForm.vue";
import ClosingRateModal from "../rate-plans/ClosingRateModal.vue";
import Contacts from "../sales-channel-contacts/Index.vue";
import PromotionsList from "./IndexPromotions.vue";
import RatePlansModule from "./rate-plans/IndexRatePlans.vue"
export default {
	props: {
		unableEdit: Boolean,
		modelId: {
			type: Number,
			required: false,
			default: -1
		},
		modalId: {
			type: String,
			required: true
		}
	},
	components: { ModelForm, Contacts, ClosingRateModal , PromotionsList ,RatePlansModule},
	data() {
		return {
			loading: true,
			loadedTabs: [],
			defaultModelInfo: {
				id: -1,
				code: "",
				name: "",
				description: "",
				status: "active",
				settingVars: {
					blockEdit: false,
					compareRates: true,
					updateRatesByCalculation: true,
					defaultCutoff: 0
				},
			},
			statusOptions: [
				{ value: "active", text: "Activo" },
				{ value: "inactive", text: "Inactivo" }
			],
			currentTab: "general",
			TypeOfClousure: "expire",
		};
	},
	computed: {},
	methods: {
		successCallback(event) {
			if(event.data?.id) this.$emit('model-id',event.data.id);
			this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["salesChannelsOpts"],
				forceRefresh: true
			});
		},
		updateSettings() {

			let defaultCutoff = 0
			if (!isNaN(this.defaultModelInfo.settingVars.defaultCutoff)) {
				defaultCutoff = parseInt(this.defaultModelInfo.settingVars.defaultCutoff)
			}

			let settings = {
				blockEdit : this.defaultModelInfo.settingVars.blockEdit,
				compareRates : this.defaultModelInfo.settingVars.compareRates,
				updateRatesByCalculation : this.defaultModelInfo.settingVars.updateRatesByCalculation,
				defaultCutoff: defaultCutoff
			}

			this.$root.api.put(`/sales-channels/${this.modelId}/setting-vars`,{ settings }).then(() => {
				this.$root.showAlert('Configuraciones actualizadas')
				this.loading = false
			}).catch(this.$root.handleRequestError);
		},
	},
	mounted() {
	},
	watch: {
		modelId: function() {
			
		}
	}
};
</script>

<style></style>
